export const exposureThemes = [
  "全部",
  "暗网流出",
  "暗网截图",
  "隐藏网络",
  "暗网线索",
  "网络信息",
];

export const exposures = [
  {
    id: "ex-01",
    title: "深夜论坛的加密帖子截图合集",
    theme: "暗网截图",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20dark%20abstract%20artwork%20of%20fragmented%20encrypted%20forum%20post%20screenshots%20and%20redacted%20message%20blocks%20floating%20in%20deep%20charcoal%20shadow%20with%20faint%20crimson%20and%20warm%20amber%20glow%2C%20cinematic%20film%20grain%2C%20moody%20lighting%2C%20high%20detail%2C%20no%20text%2C%20consistent%20collection%20visual%20style&width=900&height=640&seq=hnb-card-01&orientation=landscape",
    excerpt:
      "从多个镜像快照里拼回的一组帖子截图，按时间顺序排列，保留原始排版与可见字段。",
    source: "镜像快照",
    date: "2026-09-08",
    reads: "12.4k",
    badge: "新",
  },
  {
    id: "ex-02",
    title: "一批来源不明的暗网流出文件",
    theme: "暗网流出",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20dark%20abstract%20artwork%20of%20confidential%20documents%20and%20anonymous%20file%20fragments%20dispersing%20into%20shadow%20on%20a%20deep%20charcoal%20background%20with%20faint%20crimson%20and%20warm%20amber%20glow%2C%20cinematic%20grain%2C%20moody%20atmospheric%20lighting%2C%20high%20detail%2C%20no%20text%2C%20consistent%20collection%20visual%20style&width=900&height=640&seq=hnb-card-02&orientation=landscape",
    excerpt:
      "文件命名混乱、时间戳跳跃，先按体积与修改时间做了初步归拢，便于逐条对照原始片段。",
    source: "匿名提交",
    date: "2026-09-06",
    reads: "9.8k",
  },
  {
    id: "ex-03",
    title: "隐藏在普通域名背后的镜像站网络",
    theme: "隐藏网络",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20dark%20abstract%20artwork%20of%20a%20vast%20mirrored%20network%20of%20glowing%20nodes%20and%20duplicated%20website%20reflections%20on%20a%20deep%20charcoal%20background%20with%20faint%20crimson%20and%20warm%20amber%20glow%2C%20cinematic%20film%20grain%2C%20moody%20lighting%2C%20high%20detail%2C%20no%20text%2C%20consistent%20collection%20visual%20style&width=900&height=640&seq=hnb-card-03&orientation=landscape",
    excerpt:
      "同一份内容散落在多个镜像入口，梳理出它们之间的跳转路径与共用节点。",
    source: "线索整理",
    date: "2026-09-04",
    reads: "7.1k",
  },
  {
    id: "ex-04",
    title: "时间戳对不上：三份线索的交叉比对",
    theme: "暗网线索",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20dark%20abstract%20artwork%20of%20overlapping%20timestamp%20grids%20and%20crossing%20connection%20lines%20on%20a%20deep%20charcoal%20background%20with%20faint%20crimson%20and%20warm%20amber%20glow%2C%20cinematic%20film%20grain%2C%20moody%20atmospheric%20lighting%2C%20high%20detail%2C%20no%20text%2C%20consistent%20collection%20visual%20style&width=900&height=640&seq=hnb-card-04&orientation=landscape",
    excerpt:
      "三份材料里对同一事件的记录互相矛盾，把时间轴并排放好之后差异一眼可见。",
    source: "原创整理",
    date: "2026-09-02",
    reads: "6.5k",
    badge: "对比",
  },
  {
    id: "ex-05",
    title: "被反复删除又重新上线的信息碎片",
    theme: "网络信息",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20dark%20abstract%20artwork%20of%20shredded%20information%20fragments%20and%20deleted%20messages%20slowly%20reassembling%20on%20a%20deep%20charcoal%20background%20with%20faint%20crimson%20and%20warm%20amber%20glow%2C%20cinematic%20grain%2C%20moody%20lighting%2C%20high%20detail%2C%20no%20text%2C%20consistent%20collection%20visual%20style&width=900&height=640&seq=hnb-card-05&orientation=landscape",
    excerpt:
      "记录同一段文字在不同存档中的出现与消失，保留每一次变动的痕迹。",
    source: "存档抓取",
    date: "2026-08-30",
    reads: "5.2k",
  },
  {
    id: "ex-06",
    title: "匿名钱包地址背后的关联图谱",
    theme: "暗网线索",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20dark%20abstract%20artwork%20of%20a%20linked%20graph%20of%20anonymous%20wallet%20addresses%20and%20glowing%20transaction%20threads%20on%20a%20deep%20charcoal%20background%20with%20faint%20crimson%20and%20warm%20amber%20glow%2C%20cinematic%20film%20grain%2C%20moody%20lighting%2C%20high%20detail%2C%20no%20text%2C%20consistent%20collection%20visual%20style&width=900&height=640&seq=hnb-card-06&orientation=landscape",
    excerpt:
      "把公开可见的交易记录连成图谱，标出重复出现的节点，便于后续核对。",
    source: "线索整理",
    date: "2026-08-27",
    reads: "4.9k",
  },
  {
    id: "ex-07",
    title: "截图中被涂黑的三个字段",
    theme: "暗网截图",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20dark%20abstract%20artwork%20of%20document%20pages%20covered%20with%20heavy%20black%20redaction%20blocks%20on%20a%20deep%20charcoal%20background%20with%20faint%20crimson%20and%20warm%20amber%20glow%2C%20cinematic%20film%20grain%2C%20moody%20atmospheric%20lighting%2C%20high%20detail%2C%20no%20text%2C%20consistent%20collection%20visual%20style&width=900&height=640&seq=hnb-card-07&orientation=landscape",
    excerpt:
      "原始截图里三处关键字段被遮挡，整理了附近残留的像素与上下文供参考。",
    source: "镜像快照",
    date: "2026-08-24",
    reads: "8.3k",
  },
  {
    id: "ex-08",
    title: "从旧版缓存里翻出的原始片段",
    theme: "暗网流出",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20dark%20abstract%20artwork%20of%20a%20dusty%20archive%20of%20old%20web%20page%20fragments%20and%20broken%20links%20on%20a%20deep%20charcoal%20background%20with%20faint%20crimson%20and%20warm%20amber%20glow%2C%20cinematic%20film%20grain%2C%20moody%20lighting%2C%20high%20detail%2C%20no%20text%2C%20consistent%20collection%20visual%20style&width=900&height=640&seq=hnb-card-08&orientation=landscape",
    excerpt:
      "较早的缓存版本保留了后来被修改的段落，与现行版本逐字对照后列出。",
    source: "缓存归档",
    date: "2026-08-21",
    reads: "3.7k",
  },
];